import LangEnum from '../../../../../../../lang/LangEnum';
import { CatalogProductsTestIds } from '../../../../../../../utils/testIds/CatalogProducts.testIds';
import { CatalogSectionSortCriterionEnum } from '../../../../../enums/catalogSectionSortCriterion.enum';
import { CatalogViewGroupBy } from '../../../view/catalogView.types';
import { resolveSortOptions } from '../../../view/resolveViewCombination';
import CatalogViewClassificationTypeRow from './CatalogViewClassificationTypeRow';
import CatalogViewSettingsRow from './CatalogViewSettingsRow';
import CatalogViewValueSelect from './CatalogViewValueSelect';

interface CatalogViewSortSectionProps {
  sortCriterion: CatalogSectionSortCriterionEnum;
  groupBy: CatalogViewGroupBy;
  sortTargetId: string | null;
  isLoading: boolean;
  isSortTargetMissing: boolean;
  onSortCriterionChange: (sortCriterion: CatalogSectionSortCriterionEnum) => void;
  onSortTargetIdChange: (sortTargetId: string | null) => void;
}

const CatalogViewSortSection = ({
  sortCriterion,
  groupBy,
  sortTargetId,
  isLoading,
  isSortTargetMissing,
  onSortCriterionChange,
  onSortTargetIdChange,
}: CatalogViewSortSectionProps) => {
  return (
    <>
      <CatalogViewSettingsRow label={LangEnum.GLOBAL_FILTER_ORDER_BY}>
        <CatalogViewValueSelect
          label={LangEnum.GLOBAL_FILTER_ORDER_BY}
          value={sortCriterion}
          options={resolveSortOptions({ sortCriterion, groupBy })}
          testId={CatalogProductsTestIds.VIEW_SORT_BY_SELECT}
          disabled={isLoading}
          onChange={onSortCriterionChange}
        />
      </CatalogViewSettingsRow>
      {sortCriterion === CatalogSectionSortCriterionEnum.CLASSIFICATION_TYPE && (
        <CatalogViewClassificationTypeRow
          testId={CatalogProductsTestIds.VIEW_CLASSIFICATION_TYPE_SELECT}
          value={sortTargetId}
          hasError={isSortTargetMissing}
          onChange={onSortTargetIdChange}
        />
      )}
    </>
  );
};

export default CatalogViewSortSection;
